import { useMutation } from "@tanstack/react-query";
import { apiRequest } from "@shared/services/api/apiRequest";

export type Args = {
  programId: number;
  onDone: () => Promise<void>;
};

export function useFriendInvitationDelete({ programId, onDone }: Args) {
  return useMutation({
    mutationFn: async () => {
      return await apiRequest("/api/delete-platform-invitation/", "POST", {
        program_id: programId,
      });
    },
    onError: (error: Error) => {
      throw error;
    },
    onSuccess: async () => {
      await onDone();
    },
  });
}

export default useFriendInvitationDelete;
